import React from "react";
import classNames from "classnames";
import styles from './collapsed-item.module.scss';

export const CollapsedItemContent = ({children, isOpen}) => {
  return isOpen ? <div className={classNames(styles.content)}>{children}</div> : null
};
